import AdminDrawer from "../components/AdminDrawer";

import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";
import AdminDashbaordPage from "../pages/admin/dashboard";
import CompaniesPage from "../pages/admin/companies";
import CreateCompanyPage from "../pages/admin/companies/createCompany";
import ContactRequestsPage from "../pages/ContactRequests";
import FreeTrialRequestsPage from "../pages/FreeTrialRequests";
import AppSettingsPage from "../pages/admin/settings";
import AdminPlansPage from "../pages/admin/plans";
import Customer360Page from "../pages/admin/customer360";
import ChangePassword from "../pages/changePassword";

export const appAdminRouter = createBrowserRouter(
  createRoutesFromElements(
    <Route
      element={
        <>
          <AdminDrawer />
        </>
      }
      errorElement={<AdminDrawer />}
    >
      <Route index path="/" element={<AdminDashbaordPage />} />

      <Route path="/companies">
        <Route index element={<CompaniesPage />} />
        <Route path="/companies/create" element={<CreateCompanyPage />} />
        <Route path="/companies/:companyUuid" element={<Customer360Page />} />
      </Route>

      <Route path="/contacts">
        <Route index element={<ContactRequestsPage /> } />
      </Route>

      <Route path="/free-demo-requests">
        <Route index element={<FreeTrialRequestsPage />} />
      </Route>

      <Route path="/plans" element={<AdminPlansPage />} />

      <Route path="/app-settings" element={<AppSettingsPage />} />
      <Route path="/changePassword" element={<ChangePassword />} />
    </Route>
  )
);
